// extracted by mini-css-extract-plugin
export var wordContainer = "_r0-0";